module.exports = __webpack_public_path__ + "img/img_default.50b2d79f.png";